import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ProductsSearch, getAllProducts } from "../../redux/Slices/ProductSlice";

const UseViewSearchProducts = () => {

  let PriceFromRequest, PriceToRequest, searchInputTextValue = "";
  let PriceFrom, PriceTo = 0
  let CategoriesValues, BrandsValues = [];

  const limit = 10
  const dispatch = useDispatch();
  const [SearchLoading, setSearchLoading] = useState(true)
  const [AllLoading, setAllLoading] = useState(true)
  const [PageLoading, setPageLoading] = useState(true)
  const [NumberOfPages, setNumberOfPages] = useState("")
  const [searchInputValue, setSearchInputValue] = useState(localStorage.getItem("SearchValue") || "")
  const [items, setItems] = useState([])
  const { allProducts, SearchProducts } = useSelector((state) => state.ProductReducer);

  // to handle the search input value and handle the redirect the page
  const onChangeSearchInput = (e) => {
    localStorage.setItem("SearchValue", e.target.value)
    setSearchInputValue(e.target.value)
    const path = window.location.pathname;
    if (path != "/shopproduct") {
      window.location.href = "/shopproduct"
    }
    localStorage.setItem("categoriesChecked", "")
    localStorage.setItem("BrandChecked", "")
    localStorage.setItem("priceFrom", "")
    localStorage.setItem("priceTo", "")
    searchProductsFunc()
  }
  // useEffect(() => {
  //   localStorage.setItem("categoriesChecked", "")
  //   localStorage.setItem("BrandChecked", "")
  //   localStorage.setItem("priceFrom", "")
  //   localStorage.setItem("priceTo", "")
  //   searchProductsFunc()
  // }, [])
  // get data from local storage
  const GetDataFromLocalStorage = () => {
    if (localStorage.getItem("SearchValue") != null) {
      searchInputTextValue = localStorage.getItem("SearchValue")
    }
    if (localStorage.getItem("categoriesChecked") != null) {
      CategoriesValues = localStorage.getItem("categoriesChecked")
    }
    if (localStorage.getItem("BrandChecked") != null) {
      BrandsValues = localStorage.getItem("BrandChecked")
    }
    if (localStorage.getItem("priceFrom") != null) {
      PriceFrom = localStorage.getItem("priceFrom")
    }
    if (localStorage.getItem("priceTo") != null) {
      PriceTo = localStorage.getItem("priceTo")
    }
    if (PriceFrom === "" || PriceFrom <= 0) {
      PriceFromRequest = ""
    } else {
      PriceFromRequest = `&price[gt]=${PriceFrom}`
    }
    if (PriceTo === "" || PriceTo <= 0) {
      PriceToRequest = ""
    } else {
      PriceToRequest = `&price[lte]=${PriceTo}`
    }
  }

  // handle get all products
  const GetAllProducts = async () => {
    try {
      HandleSort()
      setAllLoading(true)
      await dispatch(getAllProducts(`limit=${limit}&page=1&sort=${sort}`))
      setAllLoading(false)
    } catch (error) {
      console.log(error)
      setItems([])
    }
  }

  // handle search products function
  const searchProductsFunc = async () => {
    try {
      GetDataFromLocalStorage()
      HandleSort()
      setSearchLoading(true)
      await dispatch(ProductsSearch(`limit=${limit}&page=1&keyword=${searchInputTextValue}&sort=${sort}&${CategoriesValues}&${BrandsValues}&${PriceFromRequest}&${PriceToRequest}`))
      setSearchLoading(false)
    } catch (error) {
      console.log(error)
      setItems([])
    }

  }

  // handle search products function request response with search value 
  useEffect(() => {
    if (SearchLoading === false) {
      if (SearchProducts && SearchProducts.status === 200 && SearchProducts.data) {
        setItems(SearchProducts.data.data)
        setNumberOfPages(SearchProducts.data.paginationResult.numberOfPages)
      }
    }
  }, [SearchLoading])

  // handle get all products  request response
  useEffect(() => {
    if (AllLoading === false) {
      if (allProducts && allProducts.status === 200 && allProducts.data) {
        setItems(allProducts.data.data)
        setNumberOfPages(SearchProducts.data?.paginationResult?.numberOfPages)
      }
    }
  }, [AllLoading])

  // run the search products function
  useEffect(() => {
    if (localStorage.getItem("SearchValue") != null) {
      searchProductsFunc()
    } else {
      GetAllProducts()
    }
  }, [searchInputValue])


  //  search result with pagination
  const onPressPage = async (page) => {
    GetDataFromLocalStorage()
    HandleSort();
    setPageLoading(true)
    await dispatch(ProductsSearch(`page=${page}&limit=${limit}&keyword=${searchInputTextValue}&sort=${sort}&${CategoriesValues}&${BrandsValues}&${PriceFromRequest}&${PriceToRequest}`))
    setPageLoading(false)
  }

  // handle onpress page pagination request response
  useEffect(() => {
    if (PageLoading === false) {
      if (SearchProducts && SearchProducts.status === 200 && SearchProducts.data) {
        setItems(SearchProducts.data.data)
        setNumberOfPages(SearchProducts.data.paginationResult.numberOfPages)
      }
    }
  }, [PageLoading])


  // sort data with drop down filter
  let sortType = "", sort = ""
  const HandleSort = () => {
    if (localStorage.getItem("sortType") != null) {
      sortType = localStorage.getItem("sortType")
    } else {
      sortType = "";
    }
    if (sortType === "Price Z to A") {
      sort = "-price"
    } else if (sortType === "Price A to Z") {
      sort = "+price"
    } else if (sortType === "Reset Sort") {
      sort = " "
    } else if (sortType === "Best Seller") {
      sort = "-sold"
    } else if (sortType === "Best Review") {
      sort = "+quantity"
    }
  }


  return [NumberOfPages, AllLoading, SearchLoading, items, onPressPage, searchProductsFunc, onChangeSearchInput, searchInputValue]
};

export default UseViewSearchProducts;